import { BasicTeam } from "@/graphql/gql/graphql";

export function formatNFLRecord(record?: BasicTeam["record"]): string {
  const wins = record?.regularSeasonRecord?.wins ?? 0;
  const losses = record?.regularSeasonRecord?.losses ?? 0;
  return `${wins}-${losses}`;
}
